import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { Box, Button } from '@mui/material';
import { styled } from '@mui/system';
import { styles } from '../assets/styles';
import { Pkmn } from '../data/pkmnList';
import InputBox from './containers';

const GroupHeader = styled('div')(() => ({
  ...styles.groupHeader,
}));
function PokemonAutocomplete({
  options,
  value,
  onChange,
  onSubmit,
  submitButtonDisabled,
  loadingSubmit,
}) {
  return (
    <InputBox>
      <form className="form" onSubmit={onSubmit} style={styles.formMargin}>
        Type ,,,,any ,,,,POKeMON ,,,,name,, :
        <Box sx={styles.inputPokemonBoxCenter}>
          <Autocomplete
            ListboxProps={{
              style: styles.autoCompleteBoxProps,
            }}
            renderGroup={(params) => (
              <li key={params.key}>
                <GroupHeader>{params.group}</GroupHeader>
                <ul style={styles.ulPadding}>{params.children}</ul>
              </li>
            )}
            disablePortal
            forcePopupIcon={false}
            autoHighlight
            freeSolo
            groupBy={(option) => {
              for (const gen in Pkmn) {
                if (Pkmn[gen].includes(option)) {
                  return gen.replace(/(\d+)/g, ' $1');
                }
              }
            }}
            id="combo-box-demo"
            options={options}
            sx={styles.autoComplete}
            value={value}
            onChange={onChange}
            renderInput={(params) => (
              <TextField
                {...params}
                name="query"
                variant="standard"
                margintop="10px"
                InputProps={{
                  ...params.InputProps,
                  style: styles.inputProps,
                }}
              />
            )}
          />
          {/* SUBMIT BUTTON */}
          <Button
            disableRipple
            id="submit"
            type="submit"
            disabled={submitButtonDisabled}
            sx={styles.submitButton}
          >
            Submit
            {loadingSubmit && <div className="circle" style={styles.loadingSubmitCircle} />}
          </Button>
        </Box>
      </form>
    </InputBox>
  );
}

export default PokemonAutocomplete;
